import { render } from "./AddModalRegime.vue?vue&type=template&id=a852fed8&ts=true"
import script from "./AddModalRegime.vue?vue&type=script&lang=ts"
export * from "./AddModalRegime.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__